export default Object.freeze({
	readlater: {
		label: {
			add: 'Später lesen',
			remove: 'Hinzugefügt',
		},
		ariaLabel: {
			add: 'Inhalt später lesen',
			remove: 'Inhalt von Leseliste entfernen',
		},
	},
	readinglist: {
		fab: {
			toggle: {
				title: (modifierKey: string) => `Leseliste (${modifierKey} + Shift + R)`,
				ariaLabel: (modifierKey: string) => `Leseliste öffnen (${modifierKey} + Shift + R)`,
			},
			previous: {
				title: (modifierKey: string) => `Vorheriger Eintrag (${modifierKey} + Shift + Pfeil Links)`,
				ariaLabel: (modifierKey: string) =>
					`Zum vorherigen Eintrag (${modifierKey} + Shift + Pfeil Links)`,
			},
			next: {
				title: (modifierKey: string) => `Nächster Eintrag (${modifierKey} + Shift + Pfeil Rechts)`,
				ariaLabel: (modifierKey: string) =>
					`Zum nächsten Eintrag (${modifierKey} + Shift + Pfeil Rechts)`,
			},
		},
		list: {
			ariaLabel: 'Leseliste',
			deleteLabel: 'Eintrag entfernen',
			deleteAllLabel: 'Alle Einträge entfernen',
			deleteReadLabel: 'Gelesene Einträge entfernen',
		},
	},
	timestamp: {
		justNow: 'Gerade eben',
		yesterday: 'Gestern',
		updated: 'aktualisiert',
	},
	store: {
		error: {
			add: 'Beim Hinzufügen des Artikels ist ein Fehler aufgetreten',
			clear: 'Beim Löschen der Liste ist ein Fehler aufgetreten',
			default: 'Beim Bearbeiten der Liste ist ein Fehler aufgetreten',
			notWhitelisted: 'Für diese Funktion benötigen Sie ein Smart-Abo.',
			remove: 'Beim Entfernen des Artikels ist ein Fehler aufgetreten',
			removeVisited: 'Beim Entfernen der gelesenen Artikel ist ein Fehler aufgetreten',
		},
	},
});
